import { Fragment } from 'react';
import Pagination from 'react-bootstrap/Pagination';


export const SafTablePaginator = ({
    totalPages,
    currentPage,
    handlePageChange,
    handleFirst,
    handlePrevious,
    handleNext,
    handleLast,
}: {
    totalPages: number;
    currentPage: number;
    handlePageChange: (page: number) => void;
    handleFirst: (page: number) => void;
    handlePrevious: () => void;
    handleNext: () => void;
    handleLast: (page: number) => void;
}): JSX.Element => {

    let items = null;

    const getItems = (
        startNumber: number,
        endNumber: number
    ): JSX.Element[] => {
        const items = [];

        for (let number = startNumber; number <= endNumber; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    onClick={() => {
                        handlePageChange(number - 1);
                    }}
                    active={number - 1 === currentPage}
                >
                    {number}
                </Pagination.Item>
            );
        }

        return items;
    };

    if (totalPages <= 5) {
        items = getItems(1, totalPages);
    } else {
        if (currentPage <= 2) {
            items = getItems(1, 5);
        } else if (currentPage > 2 && currentPage < totalPages - 2) {
            items = getItems(currentPage - 1, currentPage + 3);
        } else {
            items = getItems(totalPages - 2, totalPages);
        }
    }
    return (
        <Fragment>
            {totalPages ? (
                <Pagination className="mb-0">
                    <Pagination.First disabled={currentPage === 0} onClick={() => handleFirst(0)} />
                    <Pagination.Prev disabled={currentPage === 0} onClick={() => handlePrevious()} />

                    {items}

                    <Pagination.Next disabled={currentPage === totalPages - 1} onClick={() => handleNext()} />
                    <Pagination.Last disabled={currentPage === totalPages - 1}
                        onClick={() => handleLast(totalPages - 1)}
                    />
                </Pagination>
            ) :
                (
                    <Pagination className="mb-0">
                        <Pagination.First disabled />
                        <Pagination.Prev disabled />
                        <Pagination.Item disabled >{0}</Pagination.Item>
                        <Pagination.Next disabled />
                        <Pagination.Last disabled />
                    </Pagination>
                )}
        </Fragment>
    );
};
